import { render } from "./WeekSelector.vue?vue&type=template&id=4f35a668&scoped=true"
import script from "./WeekSelector.vue?vue&type=script&lang=js"
export * from "./WeekSelector.vue?vue&type=script&lang=js"

import "./WeekSelector.vue?vue&type=style&index=0&id=4f35a668&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f35a668"]])

export default __exports__